import { configureStore } from '@reduxjs/toolkit'
import watch from 'redux-watch'
import { at, Many } from 'lodash'
import { loadFromLocalStorage, saveToLocalStorage } from 'util/localStorage/index'
import rootReducer from './rootReducer'
import { setFirstApply } from './filtering/firstApply'
import { getPreferenceFilters } from './filtering/saved'

export const store = configureStore({
  reducer: rootReducer,
})

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./rootReducer', () => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const newRootReducer = require('./rootReducer').default
    store.replaceReducer(newRootReducer)
  })
}
const persistingSessionFilters = [{ key: 'filters.applied', loadActions: [] }]
const persistingStates = [{ key: 'filters.firstApply', loadActions: [setFirstApply] }]

persistingSessionFilters.forEach(({ key }) => {
  const watcher = watch(store.getState, key)
  store.subscribe(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    watcher((newVal, oldVal, objectPath) => {
      const storageKey = store.getState().user.hash
      saveToLocalStorage({
        storageKey,
        key,
        data: at(store.getState(), [key] as Many<keyof RootState>)[0],
        session: true,
      })
    })
  )
})

persistingStates.forEach(({ key }) => {
  const watcher = watch(store.getState, key)
  store.subscribe(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    watcher((newVal, oldVal, objectPath) => {
      const storageKey = store.getState().user.hash

      saveToLocalStorage({
        storageKey,
        key,
        data: at(store.getState(), [key] as Many<keyof RootState>)[0],
      })
    })
  )
})

// Update with saved states in local storage, after user logs in
const userHashWatch = watch(store.getState, 'user.hash')
store.subscribe(
  userHashWatch(() => {
    const storageKey = store.getState().user.hash

    persistingStates.forEach(({ key, loadActions }) => {
      const state = loadFromLocalStorage({ storageKey, key })

      if (loadActions) {
        loadActions.forEach((loadAction) => store.dispatch(loadAction(state)))
      }
    })
  })
)

const userJwtWatch = watch(store.getState, 'user.jwt')
store.subscribe(
  userJwtWatch(() => {
    // pull saved filters from preference API
    store.dispatch(getPreferenceFilters())
  })
)

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch

export default store
